/** Text helpers for the simple Review page, kept free of React so they are unit-tested. */
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** "2026-10-07" becomes "Oct 7, 2026" in text written for people. */
export function plainDates(text: string) {
  return text.replace(/\b(\d{4})-(\d{2})-(\d{2})\b/g, (whole, y: string, m: string, d: string) => {
    const month = months[Number(m) - 1];
    return month ? `${month} ${Number(d)}, ${y}` : whole;
  });
}
/** A question task reads "<question> <Agent> recommends: <suggestion> (draft …)"; split it so each is said once. */
export function splitQuestion(title: string) {
  const match = /^(.*?)\s+\S+ recommends:\s*(.*?)(?:\s*\(draft [^)]*\))?$/s.exec(title);
  return match ? { question: match[1]!.trim(), suggestion: match[2]!.trim() } : { question: title.trim(), suggestion: '' };
}
